import { Colors } from "@auteco/theme";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
    btn: {
        marginBottom: '20px',
        width: '120px',
        backgroundColor: '#f0F0F0',
        border: `2px solid ${Colors.DARK_BLUE}`,
        color: Colors.DARK_BLUE,
    }
}))

export { useStyles }